class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (this.mainDetailsToggle.open) this.fitSubmenu();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // Cap long dropdowns at HeaderMenu.visibleItems and a half (fewer if the window is short),
  // so the cut-off item shows there is more to scroll.
  fitSubmenu() {
    const list = this.content;
    list.style.maxHeight = '';
    list.scrollTop = 0;
    const items = list.querySelectorAll(':scope > li');
    if (items.length <= HeaderMenu.visibleItems + 1) return;

    const available = window.innerHeight - list.getBoundingClientRect().top - 20;
    const peek = (i) => items[i].offsetTop + items[i].offsetHeight / 2;
    let index = HeaderMenu.visibleItems;
    while (index > 1 && peek(index) > available) index--;
    list.style.maxHeight = `${Math.round(peek(index))}px`;
  }
}

HeaderMenu.visibleItems = 13;

customElements.define('header-menu', HeaderMenu);
